import { cacheDom } from '../utils/QuerySelectors.js'

const dom = {}
const qs = {
  section: 'data-section-type="archive-details"',
  head: 'data-archive-head',
  swiperElement: 'data-archive-slider',
  lookbookDesc: 'data-look-description',
  lookbookIndex: 'data-look-index',
  zoomContainer: 'data-lookbook-zoom',
  zoomClose: 'data-lookbook-close',
  zoomImage: 'data-lookbook-img',
}
const qsAll = {
  cards: 'data-archive-card',
  zoomTriggers: 'data-zoom-trigger',
}

const state = {
  swiper: null,
  footer: document.querySelector('#shopify-section-footer'),
}
export const setupArchiveDetails = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    dom.cards.forEach((card) => {
      card.addEventListener('click', (e) => {
        e.preventDefault()
        const url = card.href
        const index = card.dataset.index
        history.pushState({}, '', url)
        if (dom.section.querySelector(`[${qs.head}]`)) {
          if (dom.head.querySelector('video')) dom.head.querySelector('video').muted = true
          dom.head.remove()

          dom.swiperElement.classList.add('mx-auto', 'md:w-[calc(33.33%-16.67px)]')
          dom.swiperElement.querySelector('.archive-list').classList.add('swiper-wrapper', '!gap-0')
          dom.lookbookIndex.innerHTML = index
          dom.lookbookDesc.classList.add('!block')
          state.swiper = new Swiper(dom.swiperElement, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 25,
            slideToClickedSlide: true,
            initialSlide: index - 1,
            on: {
              slideChange: () => {
                setTimeout(() => {
                  const activeSlide = dom.swiperElement.querySelector('.swiper-slide-active')
                  if (activeSlide) {
                    history.pushState({}, '', activeSlide.href)
                    dom.lookbookIndex.innerHTML = activeSlide.dataset.index
                  }
                }, 300)
              },
            },
          })
          window.scrollTo(0, 0)
        }
      })
    })
    dom.zoomTriggers.forEach((zoomTrigger) => {
      zoomTrigger.addEventListener('click', () => {
        dom.section.classList.add('!hidden')
        state.footer.classList.add('!hidden')
        dom.zoomContainer.classList.add('!block')
        dom.zoomImage.innerHTML = `<img class="w-full" src="${zoomTrigger.dataset.image}" />`
      })
    })
    dom.zoomClose.addEventListener('click', () => {
      dom.zoomContainer.classList.remove('!block')
      dom.zoomImage.innerHTML = ''
      dom.section.classList.remove('!hidden')
      state.footer.classList.remove('!hidden')
    })
    const params = new URL(document.location).searchParams
    const lookbookIndex = params.get('look')
    if (lookbookIndex) {
      const card = Array.from(dom.cards)[lookbookIndex - 1]
      const clickEvent = new Event('click')
      card.dispatchEvent(clickEvent)
    }
  }
}
